import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from '@src/app/core/services/api.service';
import { CobrandingInfoResponse } from '@src/app/core/models/v1/response/cobranding.info.response.model';
import { StorageService } from '@src/app/core/services/storage.service';

@Component({
  selector: 'app-cobranding-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cobranding-banner.component.html',
  styleUrls: ['./cobranding-banner.component.scss']
})
export class CobrandingBannerComponent {

  agencyName: string = '';
  agencyLogo: string = '';
  agencyColor: string = '#ffe6d4';
  isCobranded: boolean = false;

  @Output() bannerRendered = new EventEmitter<void>();

  constructor(private apiService: ApiService,private storageService : StorageService) {
    this.getCobrandingDetails();
  }

  async getCobrandingDetails() {
    const brandingInfo = JSON.parse(localStorage.getItem("cobranding-information") || "")
    if (brandingInfo) {
      this.agencyName = brandingInfo.agencyName;
      this.agencyLogo = brandingInfo.logoPath;
      this.agencyColor = '#ffe6d4';
      this.isCobranded = this.agencyName != '' || this.agencyLogo != '';
      if(brandingInfo.agencyId){
        this.checkForMiniEnv(brandingInfo.agencyId)
      }
      if (this.isCobranded) {
        this.bannerRendered.emit();
      }
    }
  }
  async checkForMiniEnv(agencyId : string){
    if(!this.storageService.getAppModel().isMiniEnv){
          await this.apiService.searchForIdInsideMiniEnv(agencyId, "agency_id")
          if(this.storageService.getAppModel().isMiniEnv){
            window.location.reload()
          }
    }
  }
} 